import { postRequest } from '@/core';
import { packageTypes } from '@/requests';

export default async function syncPackageTypes() {
	let url = packageTypes.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}